<template>
  <div class="hello">
    <chatbot-widget
          :configuration="chatbotConfig"
          landscape
      >
      </chatbot-widget>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      chatbotConfig: process.env.VUE_APP_CHATBOT_CONFIGURATION
    };
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
